const BF_TRUVUE_SUPPLIER_SHEETS = [
  { widthIn: 16, heightIn: 20, supplierCostCents: 6065 },
  { widthIn: 20, heightIn: 24, supplierCostCents: 9097 },
  { widthIn: 24, heightIn: 32, supplierCostCents: 14555 },
  { widthIn: 32, heightIn: 40, supplierCostCents: 24259 },
  { widthIn: 36, heightIn: 48, supplierCostCents: 33634 },
  { widthIn: 40, heightIn: 60, supplierCostCents: 46714 },
  { widthIn: 41, heightIn: 71, supplierCostCents: 64232 },
  { widthIn: 48, heightIn: 96, supplierCostCents: 87330 },
];
const BF_TRUVUE_TAX_FACTOR = 1.1;
const BF_TRUVUE_SUPPLIER_ADJUSTMENT_FACTOR = 1.05;
const BF_TRUVUE_MIN_UPGRADE_PRICE_CENTS = 1000;
const BF_TRUVUE_PRICE_ROUNDING_CENTS = 500;
const BF_TRUVUE_SMALL_PIECE_MAX_AREA_SQUARE_INCHES = 18 * 24;
const BF_TRUVUE_SMALL_PIECE_PRICE_FACTOR = 1.2;
const BF_TRUVUE_SMALL_PIECE_PRICE_ROUNDING_CENTS = 100;
const BF_TRUVUE_SMALL_TIER_MINIMUM_CENTS = 2500;
const BF_TRUVUE_MEDIUM_TIER_MINIMUM_CENTS = 5500;

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.readyAcrylicVariants = this.readReadyAcrylicVariants();
      this.form.addEventListener('change', this.onReadyAcrylicChange.bind(this));
      this.updateReadyAcrylicDisplay();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const readyAcrylicPayload = this.buildReadyAcrylicPayload(formData);

      if (this.cart) this.cart.setActiveElement(document.activeElement);

      if (readyAcrylicPayload && readyAcrylicPayload.error) {
        this.handleErrorMessage(readyAcrylicPayload.error);
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }

      if (readyAcrylicPayload) {
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(readyAcrylicPayload);
      } else {
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    buildReadyAcrylicPayload(formData) {
      const selectedAcrylic = formData.get('properties[Acrylic]');

      if (selectedAcrylic !== 'TruVue Museum Acrylic Upgrade') return null;

      const upgradePlan = this.resolveReadyAcrylicPlan();
      if (!upgradePlan?.variantId || !upgradePlan.available) {
        return {
          error: upgradePlan?.error || 'TruVue upgrade pricing is not available for this frame size.',
        };
      }

      const frameVariantId = formData.get('id');
      const quantity = Number.parseInt(formData.get('quantity') || '1', 10) || 1;
      const frameProperties = this.propertiesFromFormData(formData);
      frameProperties['TruVue Piece Size'] = upgradePlan.pieceLabel;
      frameProperties['_TruVue Sheet Size'] = upgradePlan.sheetLabel;
      frameProperties['_TruVue Supplier Sheet Cost'] = this.formatMoney(upgradePlan.supplierCostCents);
      frameProperties['_TruVue Internal Sheet Cost'] = this.formatMoney(upgradePlan.internalCostCents);
      frameProperties['_TruVue Yield Count'] = String(upgradePlan.yieldCount);
      frameProperties['_TruVue Waste'] = upgradePlan.wasteLabel;
      frameProperties['_TruVue Cost Per Piece'] = this.formatMoney(upgradePlan.costPerPieceCents);
      frameProperties['_TruVue Internal Cost'] = this.formatMoney(upgradePlan.costPerPieceCents);
      frameProperties['_TruVue Upgrade Price'] = this.formatMoney(upgradePlan.priceCents);

      const payload = {
        items: [
          {
            id: Number(frameVariantId),
            quantity,
            properties: frameProperties,
          },
          {
            id: Number(upgradePlan.variantId),
            quantity,
            properties: {
              'For Ready-To-Ship Frame': this.dataset.readyFrameTitle || 'Ready-To-Ship Frame',
              'Ready-To-Ship Frame Size': upgradePlan.pieceLabel,
              '_TruVue Sheet Size': upgradePlan.sheetLabel,
              '_TruVue Internal Sheet Cost': this.formatMoney(upgradePlan.internalCostCents),
              '_TruVue Yield Count': String(upgradePlan.yieldCount),
              '_TruVue Waste': upgradePlan.wasteLabel,
              '_TruVue Cost Per Piece': this.formatMoney(upgradePlan.costPerPieceCents),
              '_TruVue Internal Cost': this.formatMoney(upgradePlan.costPerPieceCents),
              '_TruVue Upgrade Price': this.formatMoney(upgradePlan.priceCents),
              '_Ready-To-Ship Frame Variant': String(frameVariantId || ''),
              '_Ready-To-Ship Frame Handle': this.dataset.readyFrameHandle || '',
              '_No Tracker': 'TruVue upgrade add-on',
            },
          },
        ],
      };

      if (this.cart) {
        payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      return payload;
    }

    onReadyAcrylicChange(event) {
      if (event.target?.name === 'properties[Acrylic]') this.updateReadyAcrylicDisplay();
    }

    readReadyAcrylicVariants() {
      const variantsJson = this.querySelector('[data-ready-acrylic-upgrade-variants]');
      if (!variantsJson) return [];

      try {
        const variants = JSON.parse(variantsJson.textContent || '[]');
        return Array.isArray(variants) ? variants : [];
      } catch (error) {
        console.error('Ready-To-Ship TruVue variant data could not be read.', error);
        return [];
      }
    }

    updateReadyAcrylicDisplay() {
      if (this.dataset.readyToShip !== 'true') return;

      const plan = this.resolveReadyAcrylicPlan();
      const truVueInput = this.querySelector('[data-ready-acrylic-truvue]');
      const frameGradeInput = this.querySelector('input[name="properties[Acrylic]"][value="Frame Grade Acrylic"]');
      const note = this.querySelector('[data-ready-acrylic-truvue-note]');
      if (!truVueInput || !note) return;

      if (!plan?.available) {
        truVueInput.disabled = true;
        if (truVueInput.checked && frameGradeInput) frameGradeInput.checked = true;
        note.textContent = plan?.error || 'Unavailable';
        return;
      }

      truVueInput.disabled = false;
      note.textContent = `${plan.pieceLabel} - +${this.formatMoney(plan.priceCents)}`;
    }

    resolveReadyAcrylicPlan() {
      if (this.dataset.readyToShip !== 'true') return null;

      const dimensions = this.parseReadyFrameDimensions();
      if (!dimensions) {
        return { available: false, error: 'Size needed' };
      }

      const yieldPlan = this.bestTruVueYieldPlan(dimensions);
      if (!yieldPlan) {
        return { available: false, error: 'Unavailable for this size' };
      }

      const variant = this.matchReadyAcrylicVariant(yieldPlan.pieceLabel);
      const variantId = variant?.id || null;
      const available = Boolean(variantId) && variant?.available !== false;

      return {
        available,
        error: available ? null : 'TruVue upgrade is not configured for this frame size.',
        variantId,
        pieceLabel: yieldPlan.pieceLabel,
        sheetLabel: yieldPlan.sheetLabel,
        supplierCostCents: yieldPlan.supplierCostCents,
        internalCostCents: yieldPlan.internalCostCents,
        costPerPieceCents: yieldPlan.costPerPieceCents,
        yieldCount: yieldPlan.yieldCount,
        wasteLabel: `${Math.round(yieldPlan.wastePercent * 1000) / 10}%`,
        priceCents: Number.isFinite(variant?.priceCents) ? variant.priceCents : yieldPlan.customerUpgradePriceCents,
      };
    }

    matchReadyAcrylicVariant(pieceLabel) {
      const normalizedPieceLabel = String(pieceLabel || '').toLowerCase().replace(/\s+/g, '');
      return this.readyAcrylicVariants.find((variant) => {
        const title = String(variant.title || '').toLowerCase().replace(/\s+/g, '');
        const optionValues = Array.isArray(variant.options)
          ? variant.options.map((option) => String(option.value || '').toLowerCase().replace(/\s+/g, ''))
          : [];
        return title === normalizedPieceLabel || optionValues.includes(normalizedPieceLabel);
      }) || null;
    }

    parseReadyFrameDimensions() {
      return this.parseDimensions([
        this.dataset.readyFrameTitle,
        this.dataset.readyFrameDescription,
      ].filter(Boolean).join(' | '));
    }

    parseDimensions(value) {
      const dimensionToken = String.raw`(?:\d{1,3}(?:\s+|-)\d{1,2}\/\d{1,2}|\d{1,3}\/\d{1,2}|\d{1,3}(?:\.\d+)?)`;
      const match = String(value || '').match(
        new RegExp(`\\b(${dimensionToken})\\s*(?:"|in(?:ches)?)?\\s*(?:x|\\u00d7|by)\\s*(${dimensionToken})\\s*(?:"|in(?:ches)?)?\\b`, 'i')
      );
      if (!match) return null;

      const width = this.parseInchToken(match[1]);
      const height = this.parseInchToken(match[2]);
      if (
        width === null ||
        height === null ||
        !Number.isFinite(width) ||
        !Number.isFinite(height) ||
        width <= 0 ||
        height <= 0
      ) {
        return null;
      }

      return { width, height };
    }

    parseInchToken(value) {
      const token = String(value || '').trim().replace(/(\d)-(\d+\/\d+)/, '$1 $2');
      if (!token) return null;

      const mixed = token.match(/^(\d{1,3})\s+(\d{1,2})\/(\d{1,2})$/);
      if (mixed) {
        const whole = Number(mixed[1]);
        const numerator = Number(mixed[2]);
        const denominator = Number(mixed[3]);
        if (denominator > 0) return whole + numerator / denominator;
      }

      const fraction = token.match(/^(\d{1,3})\/(\d{1,2})$/);
      if (fraction) {
        const numerator = Number(fraction[1]);
        const denominator = Number(fraction[2]);
        if (denominator > 0) return numerator / denominator;
      }

      const decimal = Number(token);
      return Number.isFinite(decimal) ? decimal : null;
    }

    bestTruVueYieldPlan(piece) {
      return [...BF_TRUVUE_SUPPLIER_SHEETS]
        .map((sheet) => this.truVueYieldPlanForSheet(piece, sheet))
        .filter(Boolean)
        .sort((left, right) => {
          const costDifference = left.costPerPieceCents - right.costPerPieceCents;
          if (costDifference !== 0) return costDifference;
          const wasteDifference = left.wasteArea - right.wasteArea;
          if (wasteDifference !== 0) return wasteDifference;
          return left.sheet.widthIn * left.sheet.heightIn - right.sheet.widthIn * right.sheet.heightIn;
        })[0] || null;
    }

    truVueYieldPlanForSheet(piece, sheet) {
      const yieldCount = this.truVueYieldCount(piece, sheet);
      if (yieldCount < 1) return null;

      const internalCostCents = this.internalCostCents(sheet);
      const pieceArea = piece.width * piece.height;
      const usedArea = pieceArea * yieldCount;
      const sheetArea = sheet.widthIn * sheet.heightIn;
      const wasteArea = Math.max(0, sheetArea - usedArea);

      return {
        sheet,
        sheetLabel: this.sheetLabel(sheet),
        pieceLabel: this.dimensionLabel(piece),
        yieldCount,
        supplierCostCents: sheet.supplierCostCents,
        internalCostCents,
        costPerPieceCents: Math.round(internalCostCents / yieldCount),
        yieldPriceCents: this.yieldCustomerPriceCents(
          Math.round(internalCostCents / yieldCount),
          piece
        ),
        tierMinimumCents: this.tierMinimumCents(piece),
        customerUpgradePriceCents: this.customerUpgradePriceCents(
          Math.round(internalCostCents / yieldCount),
          piece
        ),
        wasteArea,
        wastePercent: sheetArea > 0 ? wasteArea / sheetArea : 0,
      };
    }

    truVueYieldCount(piece, sheet) {
      if (!this.dimensionsFitSheet(piece, sheet)) return 0;

      return Math.max(
        this.gridYield(sheet.widthIn, sheet.heightIn, piece.width, piece.height),
        this.gridYield(sheet.widthIn, sheet.heightIn, piece.height, piece.width),
        this.stripMixedYield(sheet.widthIn, sheet.heightIn, piece.width, piece.height),
        this.stripMixedYield(sheet.widthIn, sheet.heightIn, piece.height, piece.width),
        this.stripMixedYield(sheet.heightIn, sheet.widthIn, piece.height, piece.width),
        this.stripMixedYield(sheet.heightIn, sheet.widthIn, piece.width, piece.height),
      );
    }

    dimensionsFitSheet(piece, sheet) {
      return (
        (sheet.widthIn >= piece.width && sheet.heightIn >= piece.height) ||
        (sheet.widthIn >= piece.height && sheet.heightIn >= piece.width)
      );
    }

    gridYield(sheetWidth, sheetHeight, pieceWidth, pieceHeight) {
      return Math.floor(sheetWidth / pieceWidth) * Math.floor(sheetHeight / pieceHeight);
    }

    stripMixedYield(sheetWidth, sheetHeight, pieceWidth, pieceHeight) {
      const primaryRows = Math.floor(sheetHeight / pieceHeight);
      const primaryPerRow = Math.floor(sheetWidth / pieceWidth);
      const rotatedPerRow = Math.floor(sheetWidth / pieceHeight);
      const rotatedRowHeight = pieceWidth;
      let best = 0;

      for (let rows = 0; rows <= primaryRows; rows += 1) {
        const usedHeight = rows * pieceHeight;
        const remainingHeight = sheetHeight - usedHeight;
        const rotatedRows = Math.floor(remainingHeight / rotatedRowHeight);
        best = Math.max(best, rows * primaryPerRow + rotatedRows * rotatedPerRow);
      }

      return best;
    }

    internalCostCents(sheet) {
      return Math.round(
        sheet.supplierCostCents *
          BF_TRUVUE_TAX_FACTOR *
          BF_TRUVUE_SUPPLIER_ADJUSTMENT_FACTOR
      );
    }

    customerUpgradePriceCents(costPerPieceCents, piece) {
      const yieldPrice = this.yieldCustomerPriceCents(costPerPieceCents, piece);
      return Math.max(yieldPrice, this.tierMinimumCents(piece));
    }

    yieldCustomerPriceCents(costPerPieceCents, piece) {
      const flooredPrice = Math.max(costPerPieceCents, BF_TRUVUE_MIN_UPGRADE_PRICE_CENTS);
      const basePrice = Math.ceil(flooredPrice / BF_TRUVUE_PRICE_ROUNDING_CENTS) *
        BF_TRUVUE_PRICE_ROUNDING_CENTS;

      if (!this.isSmallTruVuePiece(piece)) return basePrice;

      return Math.round(
        (basePrice * BF_TRUVUE_SMALL_PIECE_PRICE_FACTOR) /
          BF_TRUVUE_SMALL_PIECE_PRICE_ROUNDING_CENTS
      ) * BF_TRUVUE_SMALL_PIECE_PRICE_ROUNDING_CENTS;
    }

    tierMinimumCents(piece) {
      if (
        !piece ||
        !Number.isFinite(piece.width) ||
        !Number.isFinite(piece.height) ||
        piece.width <= 0 ||
        piece.height <= 0
      ) {
        return 0;
      }

      const [shortSide, longSide] = [piece.width, piece.height].sort((left, right) => left - right);
      if (shortSide <= 8 && longSide <= 10) return BF_TRUVUE_SMALL_TIER_MINIMUM_CENTS;
      if (shortSide <= 16 && longSide <= 20) return BF_TRUVUE_MEDIUM_TIER_MINIMUM_CENTS;
      return 0;
    }

    isSmallTruVuePiece(piece) {
      return (
        piece &&
        Number.isFinite(piece.width) &&
        Number.isFinite(piece.height) &&
        piece.width > 0 &&
        piece.height > 0 &&
        piece.width * piece.height < BF_TRUVUE_SMALL_PIECE_MAX_AREA_SQUARE_INCHES
      );
    }

    sheetLabel(sheet) {
      return `${this.cleanInchValue(sheet.widthIn)}x${this.cleanInchValue(sheet.heightIn)}`;
    }

    dimensionLabel(dimensions) {
      return `${this.cleanInchValue(dimensions.width)}x${this.cleanInchValue(dimensions.height)}`;
    }

    cleanInchValue(value) {
      if (!Number.isFinite(value)) return '0';
      const rounded = Math.round(value * 1000) / 1000;
      return Number.isInteger(rounded)
        ? String(rounded)
        : String(rounded).replace(/0+$/, '').replace(/\.$/, '');
    }

    formatMoney(cents) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }

    propertiesFromFormData(formData) {
      const properties = {};

      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (!match || value === '') return;
        properties[match[1]] = value;
      });

      return properties;
    }
  });
}
